<template>
  <div v-html="markup" />
</template>

<script setup>
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import MarkdownIt from 'markdown-it';
import { API_BASE, MARKDOWN_CONFIG, PUBLICATION_STATE } from '../constants.js';
import { normalizeStrapiResponse } from '../composables/useStrapi.js';

const markup = ref('');
const markdown = new MarkdownIt(MARKDOWN_CONFIG);

const route = useRoute();

const props = defineProps({
  pagecontent: {
    type: String,
    default: '',
    required: true,
  },
});

watch(
  () => route.params.pagecontent,
  async () => {
    markup.value = '';
    if (route.params.pagecontent && route.params.pagecontent !== '') {
      const response = await fetch(
        `${API_BASE}/inhalte?status=${PUBLICATION_STATE}&filters[key][$eq]=${route.params.pagecontent}`
      );
      const data = normalizeStrapiResponse(await response.json());
      markup.value = data.data[0]
        ? markdown.render(data.data[0].attributes.Text)
        : '';
    }
  },
  { immediate: true }
);

watch(
  () => props.pagecontent,
  async () => {
    markup.value = '';
    if (props.pagecontent && props.pagecontent !== '') {
      const response = await fetch(
        `${API_BASE}/inhalte?status=${PUBLICATION_STATE}&filters[key][$eq]=${props.pagecontent}`
      );
      const data = normalizeStrapiResponse(await response.json());
      markup.value = data.data[0]
        ? markdown.render(data.data[0].attributes.Text)
        : '';
    }
  },
  { immediate: true }
);
</script>
